










































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  Configuration,
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic
} from "@/configuration";
import Axios from "axios";
import API from "@/api";
import DniField from "@/components/DniFieldBusiness.vue";
import { EventBus } from "@/main";

@Component({
  metaInfo: {
    title: "ChileCompra",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  data() {
    return {
      RedCapital,
      SelectedCountry,
      valid: true,
      dialog: false,
      phone: "",
      contact: null,
      errorMessage: null,
      name: null,
      dni: "",
      email: null,
      contactMessage: null,
      errorRut: null,
      rules: {
        name: [(v: any) => !!v || "Nombre es requerido"],
        phone: [
          (v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros",
          (v: any) => v.length == 9 || "El teléfono debe tener 9 números."
        ],
        dni: [
          (v: any) =>
          // @ts-ignore
            !!v || `${RedCapital[SelectedCountry].DniName} es requerido`,
          (v: any) =>

            /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/.test(v) ||
            // @ts-ignore
            `${RedCapital[SelectedCountry].DniName} invalido Ej: 12.345.678-9`
        ],
        email: [
          (v: any) => !!v || "E-mail es requerido",
          (v: any) => /^.+@.+\..+/gi.test(v) || "El e-mail tiene que ser valido"
        ]
      }
    };
  },
  mounted() {
    if (this.$route.query.rut !== undefined) {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.sii}${this.$route.query.rut.toUpperCase()}`
      )
        .then((res: any) => {
          this.$data.dni = this.$route.query.rut;
          this.$data.name = res.data.razon_social;
          EventBus.$emit("snack-success", "Rut validado");
        })
        .catch((error: any) => {
          this.$data.errorRut = error.response.data.error.message;
          EventBus.$emit("snack-error", this.$data.errorRut);
          window.location.reload();
        });
    }
  },
  methods: {
    async validate(response) {
      // @ts-ignore
      if (this.$refs.form.validate()) {
        // @ts-ignore
        // this.$data.contactMessage = `*ChileCompra - ${this.$data.name} / ${this.$data.dni}`
        // @ts-ignore
        API.landing
          .chilecompra(
            this.$data.contact,
            this.$data.email,
            this.$data.contactMessage,
            // @ts-ignore
            RedCapital[SelectedCountry].PhoneCode + this.$data.phone,
            this.$data.dni,
            this.$data.name
          )
          .then((data: any) => {
            this.$data.dialog = true;
            setTimeout(() => {
              this.$router.push({
                path: "/chilecompra-exitosa"
              });
            }, Configuration.Redirection.timeout);
          })
          .catch(res => {
            this.$data.errorMessage = "Error";
          });
      }
    }
  },
  components: {
    DniField
  }
})
export default class ChileCompraForm extends Vue {}
